import React from "react";

export default function SearchBox({ value, onChange }) {
  return (
    <input
      type="text"
      placeholder="Search..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: "50%",
        padding: "8px",
        borderRadius: "6px",
        border: "1px solid #ccc",
      }}
    />
  );
}
